import { useCallback, useEffect, useState } from "react";
import { SimpleHttp } from "src/lib/utils/SimpleHTTP";

/**
 * Fetch all stacks from server
 * @param {string} stack
 * Stack Id
 * @param {boolean} enabled
 */
export default function useGetSpecialties(stack) {
  const [specialties, setSpecialties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();

  const [retryCount, setRetry] = useState(0);

  const retry = () => {
    setRetry((prev) => ++prev);
  };

  const fetchData = useCallback(
    async () => {
      setLoading(true);
      setError(undefined);

      try {
        const { status, data, error } = await SimpleHttp.getNoAuth(
          `/api/v1/comp/getLanguagesBasedOnStacks/${stack}`
        );

        if (status === true) {
          setSpecialties(data);
        } else {
          // toast.error(error?.message)
          console.log("Specialty Error:", error);
        }
      } catch (error) {
        console.log("Specialty Error:", error);
        setError(error);
      }

      setLoading(false);
    },
    [stack],
  )

  useEffect(() => {
    setLoading(true);
    fetchData();
  }, [retryCount, stack]);

  return { specialties, loading, error, retry };
}
